module.exports = __webpack_public_path__ + "img/beefeater-footer-logo.d6a8a403.svg";